import axios from 'axios';

const abdmClient = axios.create({
  baseURL: '/nodeapi/abdm', // Assuming a sub-route for ABDM
  timeout: 30000,
});

/** * Request Interceptor - Commented out for now as per requirements.
 * This will be used later to attach ABDM-specific tokens (like X-Token or Authorization).
 */
/*
abdmClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("abdm_token"); 
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
*/

export const abdmAPI = {
  // ---------- Common ----------
  encryptAPI: async (data) =>
    (await abdmClient.post("/encrypt", data)).data,

  abdmAccessToken: async () =>
    (await abdmClient.get("/access-token")).data,

  // ---------- Aadhaar verification ----------
  sendAadhaarOtp: async (data, config = {}) =>
    (await abdmClient.post("/send-aadhaar-otp", data, config)).data,

  verifyAadhaarOtp: async (data, config = {}) =>
    (await abdmClient.post("/verify-aadhaar-otp", data, config)).data,

  abhaEnrollSuggestions: async (data, config = {}) =>
    (await abdmClient.post("/abha-enroll-suggestion", data, config)).data,

  preferredAbhaAddress: async (data, config = {}) =>
    (await abdmClient.post("/preferred-abha-address", data, config)).data,

  sendMobileUpdateOtp: async (data, config = {}) =>
    (await abdmClient.post("/send-mobile-update-otp", data, config)).data,

  verifyMobileUpdateOtp: async (data, config = {}) =>
    (await abdmClient.post("/verify-mobile-update-otp", data, config)).data,

  // ---------- Mobile verification ----------
  searchByMobile: async (data, config = {}) =>
    (await abdmClient.post("/search-by-mobile", data, config)).data,

  sendMobileOtp: async (data, config = {}) =>
    (await abdmClient.post("/send-mobile-otp", data, config)).data,

  verifyMobileOtp: async (data, config = {}) =>
    (await abdmClient.post("/verify-mobile-otp", data, config)).data,

  verifyAbhaUser: async (data, config = {}) =>
    (await abdmClient.post("/verify-user", data, config)).data,

  // ---------- ABHA verification ----------
  sendAbhaOtp: async (data, config = {}) =>
    (await abdmClient.post("/send-abha-otp", data, config)).data,

  verifyAbhaOtp: async (data, config = {}) =>
    (await abdmClient.post("/verify-abha-otp", data, config)).data,

  verifyAbhaOtpUser: async (data, config = {}) =>
    (await abdmClient.post("/get-profile", data, config)).data,

  // ---------- demographic authentication ----------
  userDemographicVerify: async (data, config = {}) =>
    (await abdmClient.post("/user-demo-auth", data, config)).data,
};